import _Divider from "@mui/material/Divider";
import _List from "@mui/material/List";
import _ListItem from "@mui/material/ListItem";
import _ListItemText from "@mui/material/ListItemText";
import _ListItemIcon from "@mui/material/ListItemIcon";
import React from 'react';
import { useTranslation } from 'react-i18next';
import { styled } from 'styled-components';
import { AppService } from '../../services';
import { DedicatedRoadsLegendIcon, ExclusionZonesLegendIcon, MainRoutesLegendIcon, OppositesLegendIcon, SharedRoadsLegendIcon, TemporaryFacilitiesLegendIcon, TrafficCalmingZonesLegendIcon } from '../icons';
const items = [{
  key: 'dedicatedRoads',
  Icon: DedicatedRoadsLegendIcon,
  labelKey: 'commons.facilities_legend.dedicated_roads',
  descriptionKey: 'commons.facilities_legend.dedicated_roads_description'
}, {
  key: 'opposites',
  Icon: OppositesLegendIcon,
  labelKey: 'commons.facilities_legend.opposites'
}, {
  key: 'sharedRoads',
  Icon: SharedRoadsLegendIcon,
  labelKey: 'commons.facilities_legend.shared_roads',
  descriptionKey: 'commons.facilities_legend.shared_roads_description'
}, {
  key: 'trafficCalmingZones',
  Icon: TrafficCalmingZonesLegendIcon,
  labelKey: 'commons.facilities_legend.traffic_calming_zones',
  descriptionKey: 'commons.facilities_legend.traffic_calming_zones_description'
}, {
  key: 'temporaryFacilities',
  Icon: TemporaryFacilitiesLegendIcon,
  labelKey: 'commons.facilities_legend.temporary_facilities'
}, {
  key: 'exclusionZones',
  Icon: ExclusionZonesLegendIcon,
  labelKey: 'commons.facilities_legend.exclusion_zones',
  descriptionKey: 'commons.facilities_legend.exclusion_zones_description'
}, {
  key: 'mainRoutes',
  Icon: MainRoutesLegendIcon,
  labelKey: 'commons.facilities_legend.main_routes',
  descriptionKey: 'commons.facilities_legend.main_routes_description'
}];
export function FacilitiesLegend({
  row,
  selectedFacilities,
  enableDescriptions,
  layers
}) {
  const {
    t
  } = useTranslation();
  const {
    enableTmpFacilities
  } = AppService.environment;
  return /*#__PURE__*/React.createElement(_List, {
    dense: true,
    sx: {
      display: 'flex',
      flexDirection: row ? 'row' : 'column',
      flexWrap: row ? 'wrap' : undefined,
      columnGap: 2,
      rowGap: row ? 1 : 2,
      padding: 0,
      width: '100%',
      li: {
        padding: 0,
        width: row ? 'auto' : '100%'
      }
    }
  }, layers && /*#__PURE__*/React.createElement(React.Fragment, null, layers.map(({
    id,
    name,
    LegendIcon
  }) => /*#__PURE__*/React.createElement(_ListItem, {
    key: id
  }, /*#__PURE__*/React.createElement(_ListItemIcon, null, LegendIcon && /*#__PURE__*/React.createElement(LegendIcon, null)), /*#__PURE__*/React.createElement(_ListItemText, {
    primary: name,
    slotProps: {
      primary: {
        fontWeight: 600
      }
    },
    sx: {
      margin: 0
    }
  }))), /*#__PURE__*/React.createElement(StyledDivider, null)), items.filter(({
    key
  }) => (enableTmpFacilities || key !== 'temporaryFacilities') && (!selectedFacilities || key === 'dedicatedRoads' && (selectedFacilities.includes('cycleway') || selectedFacilities.includes('greenway')) || key === 'sharedRoads' && (selectedFacilities.includes('lane') || selectedFacilities.includes('sharebusway')) || key === 'opposites' && selectedFacilities.includes('opposite') || key === 'trafficCalmingZones' && selectedFacilities.includes('mixedfacilities'))).map(({
    key,
    Icon,
    labelKey,
    descriptionKey
  }) => /*#__PURE__*/React.createElement(_ListItem, {
    key: key
  }, /*#__PURE__*/React.createElement(_ListItemIcon, {
    sx: row ? {
      minWidth: 40
    } : {
      alignSelf: 'flex-start'
    }
  }, /*#__PURE__*/React.createElement(Icon, null)), /*#__PURE__*/React.createElement(_ListItemText, {
    primary: t(labelKey, {
      context: row ? 'short' : ''
    }),
    secondary: enableDescriptions && descriptionKey && t(descriptionKey),
    slotProps: {
      primary: row ? {} : {
        fontWeight: 600
      },
      secondary: {
        color: 'inherit',
        marginTop: 0.5,
        variant: 'body2'
      }
    },
    sx: {
      margin: 0
    }
  }))));
}
const StyledDivider = styled(_Divider)`
  && {
    margin: 8px 0;
  }
`;